import styled from 'styled-components';

import BlogArticleArchiveHero from '@klaviyo-mkt/gatsby-components/organisms/blog-article-archive-hero';
import { Breadcrumbs } from '@klaviyo-mkt/gatsby-components/molecules/breadcrumbs';
import Grid from '@klaviyo-mkt/gatsby-components/utils/grid';
import Icon from '@klaviyo-mkt/gatsby-components/atoms/icon';
import NavigationCategorySelection from '@klaviyo-mkt/gatsby-components/organisms/navigation-category-selection';
import Typography from '@klaviyo-mkt/gatsby-components/atoms/typography';

export const BreadcrumbsContainer = styled(Grid)`
  display: block;
`;

export const CategoryBreadcrumbs = styled(Breadcrumbs)`
  grid-column: 1 / -1;
  margin-top: 0;
  margin-bottom: 3.6rem;
`;

export const CategoryPage = styled.div`
  padding-top: 2.8rem;
`;

export const CategoryHero = styled(BlogArticleArchiveHero)`
  margin-top: 1.6rem;
  margin-bottom: 5.6rem;
`;

export const CategoryCardsTitle = styled(Typography)`
  border-top: 1px solid var(--color-light-border);
  grid-column: 1 / -1;
  margin-bottom: 0;
  padding-top: ${({ theme }) => theme.globalVerticalPadding};
`;

export const StyledIcon = styled(Icon)`
  fill: inherit;
`;

export const BackToBlog = styled.div`
  ${({ theme }) => `
    margin-left: 1rem;
    font-size: 1.6rem;
    line-height 2rem;
    ${theme.fonts.sohne.semibold}
  `};
`;

export const BackToBlogAnchor = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  white-space: nowrap;
  :hover {
    color: ${({ theme }) => theme.colors.ocean};
    text-decoration: none;

    ${StyledIcon} {
      fill: ${({ theme }) => theme.colors.ocean};
    }
  }
`;

export const Categories = styled(NavigationCategorySelection)`
  background-color: white;
`;
